import React from 'react';
import { LayoutChangeEvent, StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { SharedStyles } from '@shared/styles';

export interface MBTouchableOpacityProps {
  /*
        Callback when element is pressed.
        First argument is the reference to the component itself.
    */
  onPress?: (node: React.Component) => any;

  /*
        Callback when element is pressed for a long time.
        First argument is the reference to the component itself.
    */
  onLongPress?: (node: React.Component) => any;

  onLayout?: (event: LayoutChangeEvent) => any;

  /*
        Opacity when the button is pressed down. Default is 0.5
    */
  activeOpacity?: number;

  /*
        Currently used on web as a hotfix for making the touchable's
        content expand as expected. For eg MBImage inside an MBAspect
        (scenes/chat/components/attachment/image), the height will be
        0 if we don't fill. However, if we add flex to the div,
        something like MBReactionButton not be centered in
        scenes/chat/components/message/bubble/me

        TODO(fant): fix this properly
    */
  fill?: boolean;
  center?: boolean;

  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode | React.ReactNode[];
  disabled?: boolean;
  testID?: string;
}

/*
    This component wraps a touchable opacity and returns the component reference
    in the onPress call. Very useful when showing MBActionSheet on press. Makes
    it easy to pass in the parent component required for MBActionSheet to render
    its content in the right place on web.
*/
export class MBTouchableOpacity extends React.PureComponent<MBTouchableOpacityProps> {
  // wrap onPress so that we can return "this" as parameter
  onPress = () => this.props.onPress?.(this);
  onLongPress = () => this.props.onLongPress?.(this);

  render() {
    return (
      <TouchableOpacity
        {...this.props}
        disabled={this.props.disabled || !this.props.onPress}
        style={[
          // react-native-web gives all views z-index 0 as default.
          // This causes issues when trying to overlay content in nested
          // views. Resetting to no z-index makes the HTML renderer
          // figure out the view hierarchy better.
          { zIndex: 'unset' } as any,
          this.props.style,
          this.props.fill && SharedStyles.fill,
          this.props.center && SharedStyles.centerChildren,
        ]}
        onPress={!!this.props.onPress ? this.onPress : undefined}
        onLongPress={!!this.props.onLongPress ? this.onLongPress : undefined}
        onLayout={this.props.onLayout}
      />
    );
  }
}
